module.exports = __webpack_public_path__ + "img/shop4.c568a15a.png";